import { CheckCircle2, CircleDashed, Circle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { ProblemStatus } from '@/types';

export function StatusIcon({ status }: { status: ProblemStatus }) {
  const { t } = useTranslation();
  const label = t(`status.${status}`);

  if (status === 'solved')
    return <CheckCircle2 className="h-5 w-5 text-[var(--easy)]" aria-label={label} />;
  if (status === 'attempted')
    return <CircleDashed className="h-5 w-5 text-[var(--medium)]" aria-label={label} />;
  return <Circle className="h-5 w-5 text-content-muted" aria-label={label} />;
}
